import type { LexicalEditor } from "lexical";
import { $getNearestNodeFromDOMNode } from "lexical";
import { findClosestBlockNodeKey } from "../../../kernel/helpers/findClosestBlockNodeKey";

/** 与 `blockHandleLayout.pickBlockKeyAtViewportPoint` 同逻辑；独立文件以避免类型与循环依赖问题。 */
export function pickTableBlockKeyAtViewportPoint(
  clientX: number,
  clientY: number,
  editor: LexicalEditor,
  container: HTMLElement,
): string | null {
  const el = document.elementFromPoint(clientX, clientY);
  if (!el || !container.contains(el)) return null;
  if (el.closest("[data-block-handle-region]")) return null;
  let key: string | null = null;
  editor.read(() => {
    const node = $getNearestNodeFromDOMNode(el);
    key = (findClosestBlockNodeKey as (n: unknown) => string | null)(node);
  });
  return key;
}
